module.exports = __webpack_public_path__ + "static/media/Figure13.972f7f3a.jpg";